window.burgerMenu = () => {
  document.querySelector("#input-menu").checked === true
    ? (document.documentElement.style.overflow = "hidden")
    : (document.documentElement.style.overflow = null)
}